import {
	Avatar,
	Box,
	Collapse, Divider,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText, Paper,
	Typography
} from "@mui/material";
import {useRouter} from "next/router";
import {gql, useApolloClient, useQuery} from "@apollo/client";
import React, {useEffect, useState} from "react";
import StaticAvatar from "../StaticAvatar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGoogle} from "@fortawesome/free-brands-svg-icons";
import {
	faContactCard,
	faPhone,
	faPhoneArrowUpRight,
	faPhoneHangup,
	faNote, faWindowMaximize, faWindowMinimize, faClose
} from "@fortawesome/pro-solid-svg-icons";
import {useTranslation} from "react-i18next";

const FIND_USER = gql`
	query FindLookupUser($_eq: String = "") {
		organizationUsers(where: { phoneNumber: { _eq: $_eq } }) {
			id
			firstName
			lastName
			userId
			role
			phoneNumber
		}
	}
`;


const UserLookUpComponent = ({
								 setShowUserLookup,
								 phoneNumber,
								 phoneState,
								 domainUserData,
								 queueItemId,
								 lastQueueItem,
								 domainActivity
							 }) => {
	const client = useApolloClient();
	const router = useRouter();
	const { t } = useTranslation();

	const phoneStates = {
		"IDLE": "IDLE",
		"ALERT": "ALERT",
		"BUSY": "BUSY",
		"ENDED": "ENDED",
		"LOST": "LOST"
	};

	const phoneStatusColor = {
		"ALERT": "#0A84FFFF",
		"BUSY": "#008000",
		"LOST": "#ff0000",
		"ENDED": "#808080"
	};

	const menuItems = {
		REGISTERED: {
			ALERT: [
				{
					title: t("Call back later"),
					icon: faPhoneArrowUpRight,
					onClick: () => {
						console.log("Call back later");
					}
				},
				{
					title: t("Google customer"),
					icon: faGoogle,
					onClick: () => {
						console.log("Google customer");
					}
				},
				{
					title: t("Dismiss call"),
					icon: faPhoneHangup,
					onClick: () => {
						console.log("Call back later");
					}
				}
			],
			BUSY: [
				{
					title: t("Task"),
					icon: faNote,
					onClick: () => {
						console.log("Task");
					}
				},
				{
					title: t("Customer details"),
					icon: faContactCard,
					onClick: () => {
						console.log("Google customer");
					}
				},
				{
					title: t("Dismiss call"),
					icon: faGoogle,
					onClick: () => {
						console.log("Call back later");
					}
				}
			],
			ENDED: [
				{
					title: t("Task"),
					icon: faNote,
					onClick: () => {
						console.log("Task");
					}
				},
				{
					title: t("Customer details"),
					icon: faContactCard,
					onClick: () => {
						console.log("Customer details");
					}
				},
				{
					title: t("Google customer"),
					icon: faGoogle,
					onClick: () => {
						console.log("Google customer");
					}
				}
			],
			LOST: [
				{
					title: t("Task"),
					icon: faNote,
					onClick: () => {
						console.log("Task");
					}
				},
				{
					title: t("Customer details"),
					icon: faContactCard,
					onClick: () => {
						console.log("Customer details");
					}
				},
				{
					title: t("Google customer"),
					icon: faGoogle,
					onClick: () => {
						console.log("Google customer");
					}
				}
			]
		},
		NOT_REGISTERED: {
			ALERT: [
				{
					title: t("Call back later"),
					icon: faPhoneArrowUpRight,
					onClick: () => {
						console.log("Call back later");
					}
				},
				{
					title: t("Google customer"),
					icon: faGoogle,
					onClick: () => {
						console.log("Google customer");
					}
				},
				{
					title: t("Dismiss call"),
					icon: faPhoneHangup,
					onClick: () => {
						console.log("Call back later");
					}
				}
			],
			BUSY: [
				{
					title: t("Task"),
					icon: faNote,
					onClick: () => {
						console.log("Task");
					}
				},
				{
					title: t("Customer details"),
					icon: faContactCard,
					onClick: () => {
						console.log("Google customer");
					}
				},
				{
					title: t("Dismiss call"),
					icon: faGoogle,
					onClick: () => {
						console.log("Call back later");
					}
				}
			],
			ENDED: [
				{
					title: t("Task"),
					icon: faNote,
					onClick: () => {
						console.log("Task");
					}
				},
				{
					title: t("Customer details"),
					icon: faContactCard,
					onClick: () => {
						console.log("Customer details");
					}
				},
				{
					title: t("Google customer"),
					icon: faGoogle,
					onClick: () => {
						console.log("Google customer");
					}
				}
			],
			LOST: [
				{
					title: t("Task"),
					icon: faNote,
					onClick: () => {
						console.log("Task");
					}
				},
				{
					title: t("Customer details"),
					icon: faContactCard,
					onClick: () => {
						console.log("Customer details");
					}
				},
				{
					title: t("Google customer"),
					icon: faGoogle,
					onClick: () => {
						console.log("Google customer");
					}
				}
			]
		}
	};

	const [currentPhoneState, setCurrentPhoneState] = useState(phoneState);
	const [expanded, setExpanded] = React.useState(false);

	const handleExpandClick = () => {
		setExpanded(!expanded);
	};

	const { data, loading } = useQuery(FIND_USER, {
		variables: { _eq: phoneNumber },
		fetchPolicy: "no-cache"
	});

	useEffect(() => {
		console.log("DATA: ", data);
	}, [data]);

	useEffect(() => {
		//console.log(phoneState);
		console.log("PhoneNumber: ", phoneNumber);
		console.log("domainUserData: ", domainUserData);
		if (currentPhoneState !== phoneStates.LOST && phoneState === phoneStates.IDLE) {
			if (domainActivity?.endedAt) {
				setCurrentPhoneState(phoneStates.ENDED);
			}
			else if (!domainActivity?.requestEndedAt) {
				setCurrentPhoneState(phoneStates.LOST);
			}
			else if (domainActivity?.requestEndedAt) {
				// Denne treffer også på etter avsluttet samtale, men blir håndtert av første if
				setCurrentPhoneState(phoneStates.LOST);
			}
		}

		if (phoneState === "IDLE") {
			console.log("IM DELETING CACHE");
			client.cache.evict({ fieldName: "FindLookupUser" });
		}
	}, [phoneState]);

	if (loading) {
		return <></>;
	}

	const isRegisteredCustomer = data?.organizationUsers?.length > 0 ? "REGISTERED" : "NOT_REGISTERED";

	const domainUserName =
		domainUserData?.firstName || domainUserData?.lastName
			? `${domainUserData.firstName} ${domainUserData?.lastName}`
			: null;

	const title =
		data?.organizationUsers?.length === 0
			? domainUserName ?? phoneNumber
			: `${data?.organizationUsers?.[0]?.firstName} ${data?.organizationUsers?.[0]?.lastName}`;

	const getColor = () => {
		console.log("DomainActivity: ", domainActivity, "PhoneState: ", phoneState);
		if ([phoneStates.ALERT, phoneStates.BUSY].includes(phoneState)) {
			return phoneStatusColor[phoneState];
		}
		else if (domainActivity?.endedAt && phoneState === phoneStates.IDLE) {
			return phoneStatusColor.ENDED;
		}
		else if (!domainActivity?.requestEndedAt && phoneState === phoneStates.IDLE) {
			return phoneStatusColor.LOST;
		}
		else if (domainActivity?.requestEndedAt && phoneState === phoneStates.IDLE) {
			// Denne treffer også på etter avsluttet samtale, men blir håndtert av andre if
			return phoneStatusColor.LOST;
		}

		//
		// if (domainActivity?.requestEndedAt) {
		// 	c = phoneStatusColor.ENDED;
		// 	// console.log("REQUEST ENDED AT: ", dateDiffInSeconds(domainActivity.requestEndedAt));
		// }
		// // else if (domainActivity?.endedAt) {
		// // 	c = phoneStatusColor.ENDED;
		// // 	// console.log("ENDED AT: ", dateDiffInSeconds(domainActivity.endedAt));
		// // }
		// else if (["ALERT", "BUSY"].includes(phoneState)) {
		// 	c = phoneStatusColor[phoneState];
		// 	// console.log("PHONE STATE: ", phoneState);
		// }
		// else if (!domainActivity?.requestEndedAt) { c = phoneStatusColor.LOST; }
		//  console.log("PHONE STATE: ", phoneState);
		// return c;
	};

	return (
		// <Box id={"Thebox"} sx={{height: "50px", width: "300px"}}>
		<Paper
			elevation={0}
			sx={{
				position: "absolute",
				left: "0",
				right: "0",
				top: "10px",
				maxWidth: "360px",
				width: "100%",
				height: "auto",
				minHeight: "90px",
				marginInline: "auto",
				boxShadow: "0px 0px 40px 4px rgba(0,0,0,0.5)"
			}}
		>
			 	<Box
				id={"ulu-header"}
				sx={{
					marginX: 1,
					marginTop: 1,
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					alignItems: "center"
					 }}
			>
			 		<Avatar sx={{
						 width: 20,
					height: 20,
					backgroundColor: getColor()
					 }} >
			 			<FontAwesomeIcon icon={faPhone} size={"xs"}/>
			 		</Avatar>
			 		<Box>
			 			<IconButton
			 				//expand={expanded}
			 				onClick={handleExpandClick}
						size={"small"}
			 			>
			 				<FontAwesomeIcon icon={expanded ? faWindowMinimize : faWindowMaximize} size={"2xs"} />
			 			</IconButton>
			 			<IconButton
						onClick={() => setShowUserLookup(false)}
						size={"small"}
						sx={{marginLeft: 1}}
					>
			 				<FontAwesomeIcon icon={faClose} size={"2xs"} />
			 			</IconButton>
			 		</Box>
			 	</Box>
			 	<Box sx={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
				<StaticAvatar phoneStateVisible={false} user={data?.organizationUsers?.[0]} size={40} />
				<Box sx={{display: "flex", flexDirection: "column", marginLeft: 2}}>
					<Typography variant={"h6"} sx={{fontSize: "14px", fontWeight: "bold"}} >{title}</Typography>
					<Typography>{phoneNumber}</Typography>
				</Box>
			</Box>
			<Collapse in={expanded}>
				<List disablePadding sx={{marginTop: 1}}>
					{menuItems[isRegisteredCustomer][currentPhoneState]?.map((item) => (
						<>
							<Divider/>
							<ListItem key={item.id} disablePadding sx={{height: "40px"}}>
								<ListItemButton >
									<ListItemIcon >
										<FontAwesomeIcon icon={item.icon} size={"lg"}/>
									</ListItemIcon>
									<ListItemText
										primary={item.title}
									/>
								</ListItemButton>
							</ListItem>
						</>
					))}
				</List>
			</Collapse>
		</Paper>
	);
};
export default UserLookUpComponent;
